import { comparisonData } from "@/mocks/reviews";

export default function ComparisonTable() {
  return (
    <section className="py-16 md:py-24 bg-background-100" aria-labelledby="comparison-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Seller Comparison
          </span>
          <h2 id="comparison-heading" className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Top Trusted Kakobuy Sellers
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Compare verified sellers by quality rating, price range, and shipping speed
          </p>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-hidden rounded-xl border border-background-200/50">
          <table className="w-full">
            <thead>
              <tr className="bg-background-200/40">
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-foreground-600 uppercase tracking-wider">Seller</th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-600 uppercase tracking-wider">Quality</th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-600 uppercase tracking-wider">Price</th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-600 uppercase tracking-wider">Shipping</th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-600 uppercase tracking-wider">Rating</th>
                <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-600 uppercase tracking-wider">Verified</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.seller} className={`${idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"} border-t border-background-200/30`}>
                  <td className="px-5 py-4">
                    <p className="font-semibold text-foreground-900 text-sm">{row.seller}</p>
                    <p className="text-foreground-400 text-xs mt-0.5">{row.specialty}</p>
                  </td>
                  <td className="text-center px-5 py-4">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
                      {row.quality}
                    </span>
                  </td>
                  <td className="text-center px-5 py-4 text-foreground-700 text-sm font-medium">{row.price}</td>
                  <td className="text-center px-5 py-4 text-foreground-600 text-sm">{row.shipping}</td>
                  <td className="text-center px-5 py-4">
                    <div className="flex justify-center gap-0.5">
                      {Array.from({ length: row.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                      ))}
                    </div>
                  </td>
                  <td className="text-center px-5 py-4">
                    {row.verified ? (
                      <i className="ri-verified-badge-fill text-accent-500 text-lg"></i>
                    ) : (
                      <i className="ri-close-circle-line text-foreground-300 text-lg"></i>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-4">
          {comparisonData.map((row) => (
            <div key={row.seller} className="bg-background-50 rounded-xl p-4 border border-background-200/50">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="font-semibold text-foreground-900 text-sm">{row.seller}</p>
                  <p className="text-foreground-400 text-xs">{row.specialty}</p>
                </div>
                {row.verified && <i className="ri-verified-badge-fill text-accent-500"></i>}
              </div>
              <div className="grid grid-cols-3 gap-3 text-center">
                <div>
                  <p className="text-xs text-foreground-400 mb-1">Quality</p>
                  <span className="inline-flex px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">{row.quality}</span>
                </div>
                <div>
                  <p className="text-xs text-foreground-400 mb-1">Price</p>
                  <p className="text-sm font-medium text-foreground-700">{row.price}</p>
                </div>
                <div>
                  <p className="text-xs text-foreground-400 mb-1">Shipping</p>
                  <p className="text-sm text-foreground-600">{row.shipping}</p>
                </div>
              </div>
              <div className="flex justify-center gap-0.5 mt-2">
                {Array.from({ length: row.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}